import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  max-width: 600px;
  margin: ${props => props.align === 'center' ? '0 auto' : '0'};
  margin-bottom: 15px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
`;

const Track = styled.div`
  width: 100%;
  height: ${props => props.height || '12px'};
  background: var(--glass-2);
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid var(--glass-border);
`;

const Fill = styled.div`
  height: 100%;
  width: ${props => props.percent}%;
  background: ${props => props.color || 'linear-gradient(90deg, var(--accent), var(--accent-neon))'};
  border-radius: 20px;
  transition: width 1.5s ease-in-out;
  box-shadow: 0 0 10px ${props => props.color || 'var(--accent)'};
`;

const ProgressBarWidget = ({ node }) => {
  const pct = node.content?.percent || 85;

  return (
    <Wrapper align={node.style?.desktop?.align} width={node.style?.desktop?.width}>
      <Header>
        <span>{node.content?.title || '5G Ausbau'}</span>
        <span>{pct}%</span>
      </Header>
      <Track height={node.style?.desktop?.height}>
        <Fill percent={pct} color={node.style?.desktop?.color} />
      </Track>
    </Wrapper>
  );
};

registry.register('progress_bar', {
  label: 'Progress Bar',
  icon: '📊',
  category: 'advanced',
  defaultContent: {},
  defaultStyle: { desktop: { align: 'center', height: '12px' } },
  render: ProgressBarWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Werte', fields: [{name:'content.title', label:'Titel', type:'text'}, {name:'content.percent', label:'Prozent (0-100)', type:'number'}] }] },
    { tab: 'style', groups: [{ title: 'Optik', fields: [{name:'style.desktop.color', label:'Füllfarbe (CSS Gradient/Color)', type:'text'}, {name:'style.desktop.height', label:'Dicke', type:'text'}, {name:'style.desktop.align', label:'Ausrichtung', type:'select', options:[{label:'Links', value:'flex-start'},{label:'Center', value:'center'}]}] }] }
  ]
});
